import * as Yup from 'yup';

const restrictedPasswordWords = ['teladoc', 'password'];

const oneCapTest = new RegExp(/[A-Z]+/);
const oneLowerTest = new RegExp(/[a-z]+/);
const oneSpecialTest = new RegExp(/[!"#$%&'()* +,./:;<=>?@^_`\\[{|}\]~-]+/);
const oneNumberTest = new RegExp(/[0-9]+/);

export function checkRestrictedWords(value: string | null | undefined, restrictedWords: string[]) {
  const restrictedWordsTest: RegExp = new RegExp(
    `(${Array.isArray(restrictedWords) ? restrictedWords.join('|') : restrictedWords})`,
    'i'
  );
  return value && restrictedWordsTest.test(value);
}

export function removePhoneSpecialChars(phone: string) {
  return phone.replace(/[^\d]/gi, '');
}
/* istanbul ignore next */ /* this code is not used or will be deleted in other branches */
export const phoneValidation = Yup.string()
  .required('Required')
  .test('length', 'Phone number has to be 10 digits', (val) =>
    val ? removePhoneSpecialChars(val).length === 10 : false
  );

export const passwordValidation = Yup.string()
  .min(10, 'Password is too short - should be 10 chars minimum.')
  .required('Required')
  .matches(oneCapTest, 'One capital letter')
  .matches(oneLowerTest, 'One lower case letter')
  .matches(oneSpecialTest, 'One special character (e.g. $#*)')
  .matches(oneNumberTest, 'One number')
  .test('restricted', 'Invalid password entered', (value) => !checkRestrictedWords(value, restrictedPasswordWords));

export const zipValidation = Yup.string()
  .required('Required')
  .matches(/^[0-9]+$/, 'Zip can only be numbers')
  .length(5, 'Zip must be 5 digits');

export const phoneNumberMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const zipcodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
export const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
